<template>
  <span
    v-if="show"
    class="board-type"
    :title="title"
    data-test="board-type-badge"
  >Kanban</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  boardType?: string;
}>();

// Only Kanban is badged — Scrum is the implicit default, so flagging it would
// be noise. Drives the "this row is a rolling window, not a sprint" cue.
const show = computed(() => props.boardType === "kanban");
const title = computed(
  () =>
    "Kanban board — scored over a rolling window (no sprints). Sprint-only " +
    "metrics (velocity, completion %, carryover, burnup) don't apply.",
);
</script>

<style scoped>
.board-type {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #ede9fe;
  color: #5b21b6;
  border: 1px solid #a78bfa;
}
</style>
